import { Row, Col, Typography, Anchor, Image } from 'antd';
import './styles/Support.css';  // Make sure you are using the correct CSS file
import { useEffect } from 'react';
import ScrollToHash from "../Components/Common/ScrollToHash"; // adjust the path to where you saved it
import supportArt from '../images/support-art.jpg';
import buySellMetmask from '../images/support_images/buy-sell-metamask.jpg';
import buyFromMetamaskOr from '../images/support_images/buy-from-metamask-or.jpg';
import metamaskEthereumAddressExample from '../images/metamask-ethereum-usdc-address-example.jpg';
import usdcAddressesCoinbase from '../images/usdc-addresses-coinbase.jpg';
import networksEthereunUSDCCoinbadse from '../images/networks-ethereum-usdc-coinbase.jpg';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { Link } = Anchor;



const Support = () => {
  
  const location = useLocation();

  return (
    <div className="support-container">

      <Helmet>
          <link rel="canonical" href={`https://punkypay.com${location.pathname}`} />
          <meta name="robots" content="index, follow" />
      </Helmet>
      <ScrollToHash />

      <Row justify="center">
        <Col span={24} md={20} lg={18} xl={16} className="text-center">
          <Title level={1}>Support</Title>
        </Col>
      </Row>


      {/* Support image */}
      <Row justify="center" style={{ marginTop: '20px' }}>
        <Col span={24} md={20} lg={18} xl={16} className="text-center">
          <img src={supportArt} className="support-image" alt="support" />
        </Col>
      </Row>

      <Row justify="center" style={{ marginTop: '20px', marginBottom: '60px' }}>
        <Col span={24} md={20} lg={18} xl={16}>
          <div
            style={{
              display: 'block',
              width: '100%',
              marginBottom: '250px',
            }}
          >
            <Anchor offsetTop={40} affix={false}>
              <Link href="#introduction to Punkypay" title="Introduction to Punkypay" />

              <Link
                href="#How Punkypay Works"
                title={<span style={{ paddingLeft: '1em' }}>Big Picture - How Punkypay Works</span>}
              />
              <Link
                href="#How Punkypay Saves Money"
                title={<span style={{ paddingLeft: '1em' }}>Big Picture - Why Punkypay Saves Time and Money</span>}
              />

              <Link href="#Blockchain Agnostic" title="Blockchain Agnostic" />
              <Link href="#Exchanges" title="Exchanges and Wallets" />

              <Link
                href="#Coinbase"
                title={<span style={{ paddingLeft: '1em' }}>Coinbase</span>}
              />
              <Link
                href="#Signing in Coinbase"
                title={<span style={{ paddingLeft: '2em' }}>Signing into Coinbase on Punkypay</span>}
              />
              <Link
                href="#Verify Coinbase Account"
                title={<span style={{ paddingLeft: '2em' }}>Verifying your Coinbase Account</span>}
              />
              <Link
                href="#Cost Optimization with Coinbase"
                title={<span style={{ paddingLeft: '2em' }}>Cost Optimization with Coinbase</span>}
              />
              <Link
                href="#Deposit Withdraw Crypto Coinbase"
                title={<span style={{ paddingLeft: '2em' }}>Depositing and Withdrawing USDC on Coinbase</span>}
              />
              <Link
                href="#Instantly Add and Send USDC with Coinbase"
                title={<span style={{ paddingLeft: '2em' }}>Instantly Add and Send USDC with Coinbase</span>}
              />
              <Link
                href="#Notice regarding Whitelisting"
                title={<span style={{ paddingLeft: '2em' }}>Notice regarding Whitelisting</span>}
              />
              <Link
                href="#Notice about Send Limits"
                title={<span style={{ paddingLeft: '2em' }}>Notice about Send Limits</span>}
              />

  {/* 
              <Link
                href="#Gemini"
                title={<span style={{ paddingLeft: '1em' }}>Gemini</span>}
              />
              <Link
                href="#Exchanging USDC Gemini"
                title={<span style={{ paddingLeft: '2em' }}>Exchanging USDC for local currency</span>}
              /> */}

              <Link
                href="#Metamask"
                title={<span style={{ paddingLeft: '1em' }}>Metamask</span>}
              />
              <Link
                href="#Metamask Requirements"
                title={<span style={{ paddingLeft: '2em' }}>Metamask Requirements</span>}
              />
              <Link
                href="#Integrating Metamask with Punkypay"
                title={<span style={{ paddingLeft: '2em' }}>Integrating Metamask with Punkypay</span>}
              />
              <Link
                href="#Depositing to Metamask"
                title={<span style={{ paddingLeft: '2em' }}>Depositing USDC into Metamask</span>}
              />
              <Link
                href="#Getting USDC via Binance or Coinbase"
                title={<span style={{ paddingLeft: '2em' }}>Getting USDC via Binance or Coinbase</span>}
              />
              <Link
                href="#Withdrawing from Metamask"
                title={<span style={{ paddingLeft: '2em' }}>Withdrawing from Metamask</span>}
              />
              <Link
                href="#Withdrawing from Metamask"
                title={<span style={{ paddingLeft: '3em' }}>Internal Accounts on Punkypay</span>}
              />
              <Link
                href="#Manually Send Money from Metamask"
                title={<span style={{ paddingLeft: '3em' }}>Manually Send Money from Metamask</span>}
              />

              <Link
                href="#PunkypayMailroom"
                title={<span style={{ paddingLeft: '1em' }}>Punkypay Mailroom</span>}
              />
              <Link
                href="#WhyPunkypayMailroom"
                title={<span style={{ paddingLeft: '2em' }}>Why use the Punkypay Mailroom</span>}
              />
              <Link
                href="#How to use Punkypay Mailroom"
                title={<span style={{ paddingLeft: '2em' }}>How to use the Punkypay Mailroom</span>}
              />
              <Link
                href="#Find Valid Address"
                title={<span style={{ paddingLeft: '2em' }}>How to find a Valid USDC Address</span>}
              />


              <Link
                href="#How to Pay Someone in China"
                title={<span >How to Pay Someone in China</span>}
              />

              <Link
                href="#How to open a ZA Bank Account"
                title={<span style={{ paddingLeft: '1em' }}>How to open a ZA Bank Account</span>}
              />

              <Link
                href="#Referrals"
                title={<span style={{ paddingLeft: '1em' }}>Referral Marketing Program</span>}
              />

              <Link
                href="#edge-cases"
                title={<span >Edge Cases</span>}
              />
              <Link
                href="#disconnected-during-send"
                title={<span style={{ paddingLeft: '1em' }}>What to do if you get disconnected during a send</span>}
              />
              <Link
                href="#network-congestion"
                title={<span style={{ paddingLeft: '1em' }}>Network Congestion</span>}
              />
              <Link
                href="#sent-to-wrong-person"
                title={<span style={{ paddingLeft: '1em' }}>What to do if you sent money to the wrong person</span>}
              />

          </Anchor>
        </div>
      </Col>
    </Row>

      {/* Introduction */}
      <Row justify="center">
        <Col span={24} md={20} lg={18} xl={16}>
          <Title id="introduction to Punkypay" level={2}>Introduction to Punkypay</Title>
          <Paragraph className="paragraph-custom">
            Punkypay is the cheapest and fastest way to send your money internationally. 
            The way we save time and money is by using stablecoins like USDC.  
            USDC is a cryptocurrency pegged in value to the US Dollar. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            If you read through this page and are still having troubles, please reach out to us at: <br />
            <a class="light-blue" href="mailto:support@punkypay.com">support@punkypay.com</a>.
          </Paragraph>
          


          <Title id="How Punkypay Works" level={3}>Big Picture - How Punkypay Works</Title>
          <Paragraph className="paragraph-custom">
            With Punkypay, you use the US Dollar in cryptocurrency format. This combines the speed and cost savings of cryptocurrencies with the strength of the US Dollar.
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Punkypay is like a credit card network, but rather than networking together banks, Punkypay networks together crypto exchanges.
          </Paragraph>
          <Paragraph className="paragraph-custom">
            The reason why cryptocurrencies are so inexpensive and fast is becasue they run off of blockchain technology. 
            Blockchain technology is much more efficient than the traditional banking system. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Before Punkypay, cryptocurrencies were difficult to use. 
            Spending cryptocurrency generated anxiety because it was so easy to make a mistake due to its complexities. 
            And if you make a mistake, you lose all of your money forever. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Punkypay helps relieve this problem. 
            The way Punkypay helps relieve this problem is by allowing you to send cryptocurrency to someone's email address instead of someone's hexidecimal crypto address. 
            Moreover, you don't have to worry about which "network" or "blockchain" to send your money on - Punkypay just works. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            In addition, we ensure that Punkypay has record keeping above and beyond what you would find with a standard banking transaction. 
            Things like receipts, shipping addresses, or tracking numbers can be attached to your payment. 
          </Paragraph>
          

          <Title id="How Punkypay Saves Money" level={3}>Big Picture - Why Punkypay Saves Time and Money</Title>
          <Paragraph className="paragraph-custom">
            Punkypay saves time and money becasue we use blockchain technology.
            Right now, we only transfer money via USDC - but in the future, we will offer many other currencies as well. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Punkypay requires that the merchant and customer both have a) Punkypay and b) an exchange/wallet.
          </Paragraph>
          
          <Title id="Blockchain Agnostic" level={2}>Blockchain Agnostic</Title>
          <Paragraph className="paragraph-custom">
            Punkypay is a blockchain-agnostic system. 
            What does that mean exactly? 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            It means that we don't care if you're sending your money on the Ethereum blockchain, the Solana blockchain, or whatever other blockchain - all we want to do is make sure that you can securely move your money for the lowest cost in the shortest time. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Right now we are using the Ethereum blockchain becasue the fees are very small (10 cents is common), the speed of the transaction is very fast (just a minute or few), and the security of the Ethereum blockchain is top-knotch. 
            Importantly, the Ethereum blockchain has the best interoperability with various exchanges. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            We will allow you to send money on other blockchains in the future. 
            But for the meantime, the Ethereum network is good enough. 
          </Paragraph>
          

          <Title id="Exchanges" level={2}>Exchanges and Wallets</Title>
          

          <Title id="Coinbase" level={3}>Which Exchange to Use</Title>
          <Paragraph className="paragraph-custom">
            On Punkypay, there are several different ways methods you can use to sign-in with your excahnge. 
            You can:
          </Paragraph>
            <ol>
            <Paragraph className="paragraph-custom" style={{ paddingLeft: '1em' }}>
              a) use Coinbase, 
            </Paragraph>
            <Paragraph className="paragraph-custom" style={{ paddingLeft: '1em' }}>
              b) use Metamask (while this is technically a wallet, you can link it to Binance or Coinbase), 
            </Paragraph>
            <Paragraph className="paragraph-custom" style={{ paddingLeft: '1em' }}>
              c) use the Punkypay Mailroom. 
            </Paragraph>
            </ol>
          <Paragraph className="paragraph-custom"> 
            To get a quick overview of the advantages and limits of each sign-in mechanism, please review the table below. 
          </Paragraph>
          {/* SHOW TABLE */}
          <Paragraph className="paragraph-custom">
            Note: In the future, we will integrate with more exchanges that allow for more simple payments and large business transactions. 
          </Paragraph>

          <Title id="Coinbase" level={3}>Coinbase</Title>
          <Paragraph className="paragraph-custom">
            Coinbase is an excellent exchange to use with Punkypay. 
            With Coinbase, you can spend up to $10,000 per day and receive any amount of money.
            Coinbase works best if your local bank works with USD, EUR, and GBP. 
            Technically it can be used with any currency, but the exchange rate isn't as good.
          </Paragraph>
          
          <Paragraph> 
            To watch a video about how to use Coinbase on Punkypay, <a class="light-blue" target="_blank" href="https://youtu.be/Xh_Q4g6okgg">click here</a>. 
          </Paragraph>
          

          <Title id="Signing in Coinbase" level={4}>Signing into Coinbase on Punkypay</Title>
          <Paragraph className="paragraph-custom">
            Signing into Coinbase is easy. 
            Simply navigate to the "Sign into Exchange" page and then click on Coinbase. 
            Proceed after the notice, and sign in. 
          </Paragraph>
          

          <Title id="Verify Coinbase Account" level={4}>Verifying your Coinbase Account</Title>
          <Paragraph className="paragraph-custom">
            You must have a fully verified Coinbase account to use Punkypay. 
            If you have not fully verified your account, you will be prompted to do so after logging into Coinbase. 
            Once you are fully verified with Coinbase, you will be able to use Punkypay. 
          </Paragraph>      

          
          <Title id="Cost Optimization with Coinbase" level={4}>Cost Optimization with Coinbase</Title>
          <Paragraph className="paragraph-custom">
            Coinbase is the cheapest way to use Punkypay if your bank allows you to hold USD, EUR, or GBP. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Getting USDC with USD is completely free, and it's incredibly cheap to get USDC with EUR or GBP. (As we write this in April of 2026, the cost is 0.001%.)
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Please note that you are only be able to get USDC cheaply with EUR or GBP if you use "Coinbase Advanced Trading" to convert your local moeny into USDC. 
            If you try to get USDC with EUR or GBP while using the regular Coinbase app, it will incur fees. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            To access Coinbase Advanced trading, navigate to <a class="light-blue" target="_blank" href="https://www.coinbase.com/advanced-trading">Coinbase.com/Advanced-Trading</a>
          </Paragraph>
          

          <Title id="Deposit Withdraw Crypto Coinbase" level={4}>Depositing and Withdrawing USDC on Coinbase</Title>
          <Paragraph className="paragraph-custom">
            In order to deposit or withdraw USDC on Coinbase, you must: <br />
          </Paragraph>    
          <ol className="paragraph-custom">

            <Paragraph>1) Login to <a class="light-blue" target="_blank" href="https://www.coinbase.com">Coinbase.com</a></Paragraph>
            <Paragraph>2) Search for the asset named, "USDC" and click on it. 
              (Note: There are other assets named things like "Bridged USDC" ... do not click on these. 
              Just click on the one simply named, "USDC") </Paragraph>
            <Paragraph>3) Select, "deposit" if you want to deposit USDC into Coinbase, select "Withdraw" if you want to withdraw USDC from Coinbase.</Paragraph>
            <Paragraph>4) Follow the instructions on-screen in order to deposit or withdraw your money. </Paragraph>
          </ol>   
          
          <Title id="Instantly Add and Send USDC with Coinbase" level={4}>Instantly Add and Send USDC with Coinbase</Title>
          <Paragraph className="paragraph-custom">
            In order to instantly add USDC into your coinbase account, you must hold a large value of assets on your account. 
            These assets include cryptocurrencies, stablecoins, or cash. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            If you have a <b>large</b> amount of assets in your account, you will be able to buy USDC and then immediately send it. 
            Let’s give some examples:
          </Paragraph>
          <ul className="paragraph-custom">
              <Paragraph className="paragraph-custom">
                You hold $10,000 worth of Ethereum in your Coinbase account. 
                You want to add $1,000 of USDC to your account, and then immediately send it to your business partner in Canada.
              </Paragraph>
              <Paragraph className="paragraph-custom">
                <i>You can do this because you have a large value of assets in your Coinbase account. </i>
              </Paragraph>
              <Paragraph className="paragraph-custom">
                You hold $500 worth of Ethereum in your Coinbase account. 
                You want to add $1,000 of USDC to your account, and then immediately send it to your business partner in Canada. 
              </Paragraph>
              <Paragraph className="paragraph-custom">
                <i>You will not be able to do this because you do not have enough assets to cover the cost if your bank never transfers money into your Coinbase account. </i>
              </Paragraph>
              <Paragraph className="paragraph-custom">
                You hold $1,200 worth of Ethereum in your Coinbase account. 
                You want to add $1,000 of USDC to your account, and then immediately send it to your business partner in Canada. 
              </Paragraph>
              <Paragraph className="paragraph-custom">
                <i>You will not be able to do this because if the price of Ethereum suddenly decreases by &gt;20%, you do not have enough assets to cover the cost if your bank never transfers money into your Coinbase account. </i>
              </Paragraph>
          </ul>
          <Paragraph className="paragraph-custom">
            At Punkypay, we always hold assets in our Coinbase account so we can pay overseas developers immediately. 
          </Paragraph>

          <Title id="Notice regarding Whitelisting" level={4}>Notice regarding Whitelisting</Title>
          <Paragraph className="paragraph-custom">
            You will not be able to use Coinbase on Punkypay if whitelisting is enabled. 
            If you don't know what whitelisting is, don't worry about it, you probably haven't enabled it.  
          </Paragraph>
          {/* INSERT IMAGE */}
          

          <Title id="Notice about Send Limits" level={4}>Notice about Send Limits</Title>
          <Paragraph className="paragraph-custom">
            You are only allowed to send up to $10,000 per day using Coinbase, including any minor transaction fees. 
            So if you made a transaction for exactly $10,000 and the transaction fee was $0.10, you would exceed this daily limit and not be allowed to send that amount. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            However, if you send $9,999 and the transaction fee was $0.10, you would be able to make this transaction. 
            We realize this is subtle, but we needed to make this point. 
          </Paragraph>
          {/* INSERT IMAGE */}
          
{/* 
          <Title id="Gemini" level={3}>Gemini</Title>
          <Paragraph className="paragraph-custom">
            You cannot send money with Gemini, only receive it. 
            It is an excellent exchange if your local bank works with USD, EUR, GBP, AUD, or HKD. 
            Gemini also works if your local bank deals with CAD and SGD, just not as seamlessly. 
          </Paragraph>
          <Paragraph> 
            To watch a video about how to use Gemini on Punkypay, <a class="light-blue" target="_blank" href="https://youtu.be/upGSrD7cuFo">click here</a>. 
          </Paragraph>
          

          <Title id="Exchanging USDC Gemini" level={4}>Exchanging USDC for local currency</Title>
          <Paragraph className="paragraph-custom">
            To exchange USDC which you receive on Gemini for local currency, we recommend using Gemini's <a class="light-blue" target="_blank" href="https://www.gemini.com/activetrader">Active Trader</a> feature. 
            This will save a significant amount on transaction fees when exchanging USDC for local currency. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            If your local bank works with CAD or SGD and are using Gemini, you can exchange USDC for another crypto (like Bitcoin or Ethereum), and then convert that into local currency. 
          </Paragraph> */}
          

          <Title id="Metamask" level={3}>Metamask</Title>
          <Paragraph className="paragraph-custom">
            Metamask is a crypto wallet which can synergize with Biannce or Coinbase. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Metamask is particularly useful if you do not use the USD, GBP, or EUR. 
          </Paragraph>
{/*             
            Integrating Metamask with Punkypay
            Metamask on Mobile
            Browsers you can use with Metamask
            Safeguarding Metamask 
            Free Offloading to Exchagne 
*/}

          <Title id="Integrating Metamask with Punkypay" level={4}>Integrating Metamask with Punkypay</Title>
          <Paragraph className="paragraph-custom">
            Integrating Metamask with Punkypay is easy. Here's what you do:
          </Paragraph>
          <Paragraph className="paragraph-custom">
            1) Go to the browser which has Metamask installed, or go the Mobile app. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            2) Sign into Punkypay.com and click on "Sign into Exchange"
          </Paragraph>
          <Paragraph className="paragraph-custom">
            3) Click on "Metamask"
          </Paragraph>
          <Paragraph className="paragraph-custom">
            4) Press "Connect to Metamask". You will get an error if Metamask is not set up on your browser.
          </Paragraph>

          {/* <Paragraph>
            Watch <a class="light-blue" target="_blank" href="https://youtu.be/EqWg4QScvbs">this video</a> to see how to do this.
          </Paragraph> */}

          <Title id="Metamask Requirements" level={4}>Requirements to use Metamask</Title>
          <Paragraph className="paragraph-custom">
            Metamask is only possible to use if you have one of the following:
          </Paragraph>
          <Paragraph className="paragraph-custom">
            <b>Desktop Browsers</b>
          </Paragraph>
          <Paragraph className="paragraph-custom">
          <ol>
            <li>Google Chrome</li>
            <li>Mozilla Firefox</li>
            <li>Brave</li>
            <li>Microsoft Edge</li>
            <li>Opera</li>
          </ol>
          </Paragraph>
          <Paragraph className="paragraph-custom">
            <b>Mobile Apps</b>
          </Paragraph>
          <Paragraph className="paragraph-custom">
            <ol>
              <li>The iOS "Metamask" app</li>
              <li>The Android "Metamask" app</li>
            </ol>
          </Paragraph>
          
          <Title id="Ethereum is Required to use Metamask" level={4}>Ethereum is Required to use Metamask</Title>
          <Paragraph className="paragraph-custom">
            In order to use Metamask, you need a very small amount of Ethereum in your Metamask wallet. 
            Each time you make a transaction, you will need to pay about 30 cents to the Ethereum network. 
          </Paragraph>

          <Paragraph className="paragraph-custom">ADD IMAGE</Paragraph>

          <Title id="Backing Up Metamask" level={4}>Backing up your Metamask Wallet</Title>
          <Paragraph className="paragraph-custom">
            As Metamask is a wallet, you cannot retrieve it through any sort of organization. 
            This means that you MUST back up the seed phrase for the wallet. 
            See <a class="light-blue" target="_blank" href="https://support.metamask.io/configure/wallet/how-to-reveal-your-secret-recovery-phrase/">here</a> for more details.
          </Paragraph>
          <Paragraph className="paragraph-custom">
            If you ever want to use your Metamask wallet on a new device, you have to restore your wallet using the seed phrase.
          </Paragraph>


          
          <Title id="Depositing to Metamask" level={4}>Depositing to Metamask</Title>
          <Paragraph className="paragraph-custom">
            With Metamask, there are two different ways you can get USDC. 
            You can 1) you can get USDC with Binance or Coinbase (recommended), or 2) send yourself USDC from your local exchange.
          </Paragraph>
          <Paragraph className="paragraph-custom">
            With method #1 (listed above) there is a $2,000 per day limit. With method #2, you can deposit more money at once. 
          </Paragraph>

          <Title id="Getting USDC via Binance or Coinbase" level={5}>Getting USDC via Binance or Coinbase</Title>
          <Paragraph className="paragraph-custom">
            In order to deposit money in your Metamask account with Coinbase or Metamask, do the following:
            <ol>
              <div style={{ textIndent: '2em' }}>
              <Paragraph className="paragraph-custom">
                1) Click on "Buy/Sell": 
              </Paragraph>
              <Image
                src={buySellMetmask}
                alt="buySellMetmask"
                style={{
                  maxWidth: '132px',
                  maxHeight: '293px',
                  width: '100%',
                  height: 'auto',
                }}
                preview={{
                  mask: <span>Click to enlarge</span>, // Optional overlay text
                }}
              />
              <Paragraph className="paragraph-custom">
                2) Click on the "Buy" dropdown to see "Binance and Coinbase": 
              </Paragraph>
              <Image
                src={buyFromMetamaskOr}
                alt="buyFromMetamaskOr"
                style={{
                  maxWidth: '442.5px',
                  maxHeight: '217.5px',
                  width: '100%',
                  height: 'auto',
                }}
                preview={{
                  mask: <span>Click to enlarge</span>, // Optional overlay text
                }}
              />
              <Paragraph className="paragraph-custom">
                3) Follow the remaining steps on screen in order to deposit USDC into your Metamask account.
              </Paragraph>

              </div>
            </ol>
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Coinbase is the best exchange to use if your local bank primarily deals with USD, EUR, or GBP. 
            With almost every other currency, Binance is better. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Binance allows you to easily exchange USDC with a huge large number of currencies: 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            AED, ARS, AUD, BGN, BRL, COP, CZK, EUR, GBP, HUF, IDR, MXN, NZD, PHP, PLN, RON, TRY, UAH, UGX, USD, VND, ZAR
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Binance also allows you to get USDC with any of the currencies listed below. 
            However, you will need to 1) exchange your local currency for a cryptocurrency (like Bitcoin) and then 2) exchange the cryptocurrency into USDC. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            BDT, BHD, BOB, CAD, CHF, CNY, DKK, EGP, HKD, HRK, INR, JPY, KES, KWD, KZT, MAD, MNT, OMR, PEN, PKR, QAR, SAR, SEK, THB, TWD
          </Paragraph>
          <Paragraph className="paragraph-custom">
            <i>Note: We have tried to get USDC on Metamask through other integrated providers (like Moonpay, Link by Stripe, and Transak) but these are generally much more expensive than using Binance or Coinbase.</i>
          </Paragraph>

          <Title id="Send Yourself USDC from your Exchange" level={5}>Send Yourself USDC from your Exchange</Title>
          <Paragraph className="paragraph-custom">
            If you are sending yourself USDC from your exchange, you have to send money to your "Ethereum Address" on Metamask. 
            The "Ethereum Address" may look similar to other blockchain addresses, so just be certain you grabbed the correct one. 
            We realize that this can be confusing, and we wrote an article about Ethereum USDC adddresses here. LINK TO ARTICLE
          </Paragraph>



          

          <Title id="Withdrawing from Metamask" level={4}>Withdrawing from Metamask</Title>

          <Paragraph className="paragraph-custom">
            To withdraw money from Metamask to your local currency, you will have to transfer the USDC from your Metamask account to your local crypto exchange. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            In order to do this, you will have to either a) setup an internal account on Punkypay or b) manually send money from your Metamask account. 
            We highly recommend using the first method. 
          </Paragraph>

          {/* I need two examples, one with Coinbase and one with Binance */}

          <Title id="Internal Accounts with Punkypay" level={5}>Internal Accounts with Punkypay</Title>
          <Paragraph className="paragraph-custom">
            In order to setup an internal account on Punkypay, follow the instructions below: 
          </Paragraph>

            <div style={{ textIndent: '1em' }}>
            <Paragraph className="paragraph-custom">
              1) Open up two Punkypay accounts with two individual email addresses. 
              (For instance, open up one Punkypay account with Metamask@YourCompany.com, and a second account with PunkypayMailroom@YourCompany.com)
            </Paragraph>
            <Paragraph className="paragraph-custom">
              2) On one account, sign in with Metamask. On the second account, sign in with the Punkypay Mailroom. 
              When you sign in with the Punkypay Mailroom, use an Ethereum USDC address from your local exchange. 
              (For instance, if you lived in the country of Turkey and you were able to exchange USDC for local currency on Bitlo, you would setup your second account with the Ethereum USDC address from Bitlo in the Punkypay Mailroom.) 
            </Paragraph>
            <Paragraph className="paragraph-custom">
              3) Once both accounts are setup wtih a USDC address, let Punkypay know that you would like to enable the Internal Account feature. 
              We will then enable free sends from your Metamask account to the second account you setup with the Punkypay Mailroom.
              In your email to us, please mention the two email addresses which you want to set up as internal accounts. 
            </Paragraph>
            <Paragraph className="paragraph-custom">
              <i>
                Please note that the Internal Accounts feature will be disabled automatically if you change your USDC address in the Punkypay Mailroom or setup a new Metamask account. 
                If you do this, you will have to request a new Internal Account to be setup. 
              </i>
            </Paragraph>
            </div>

          <ol>
              <div style={{ textIndent: '1em' }}>
                <Paragraph className="paragraph-custom">
                  a) Sign up with two Punkypay accounts:
                </Paragraph>
              </div>
              <div style={{ textIndent: '2em'}}>
                <Paragraph className="paragraph-custom">
                  i) One which is signed into your Metamask account
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  ii) One which is signed in with the Punkypay Mailroom
                </Paragraph>
              </div>
              <div style={{ textIndent: '1em' }}>
                <Paragraph className="paragraph-custom">
                  b) For the account which is signed in with the Punkypay Mailroom, please enter the Ethereum USDC address of your local exchange. 
                  Please be careful that you are entering in the valid Ethereum USDC address. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  c) Send the USDC from your account which is signed in with Metmask to your account which is signed in with the Punkypay Mailroom. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  d) If you want to test that this is working, try sending USDC from the account which you signed in with Metamask to the account which you signed in with the Punkypay Mailroom. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  <i>Note: You will be charged platform fees by using this method. We are actively working to relieve users of these fees. </i>
                </Paragraph>
              </div> 
          </ol>

          <Title id="Manually Send Money from Metamask" level={5}>Manually Send Money from Metamask</Title>
                <Paragraph className="paragraph-custom">
                  We do not recommend manually sending money from your Metamask account back to your local excahnge because it is possible to make a mistake, send money, and lose funds. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  If you are sending a meaningful amount of money, we recommend doing the following:
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  a) Find your Ethereum USDC address on your local exchange. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  b) Triple check the Ethereum USDC address you found is correct. 
                  You may have to do some research LINK to know that you are selecting the correct address. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  c) Send an extremely small amount of money from your Metamask wallet back to your exchange.
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  d) Wait a while and ensure that your money shows up. 
                  Some exchanges throttle the speed at which the money will be shown in your account
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  e) Once your money shows up in your exchange, send the full amount of moeny in the next transaction.
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  This is a risky process becasue it is very easy to mistakenly grab the wrong USDC address and send it improperly. 
                  Fortunately, when you are sending money to yourself, you can double, triple, quadruple check that this process is done correctly. 
                  If you are 
                </Paragraph>
{/*           
          <Paragraph className="paragraph-custom">
            Note: If your local bank works with BDT, BHD, BOB, CAD, CHF, CNY, DKK, EGP, HKD, HRK, INR, JPY, KES, KWD, KZT, MAD, MNT, OMR, PEN, PKR, QAR, SAR, SEK, THB, or TWD you will need to exchange the USDC for another currrency on Binance (like Bitcoin) before you can convert your USDC into local currency.
          </Paragraph> */}

        <Title id="PunkypayMailroom" level={3}>Punkypay Mailroom</Title>
          <Paragraph className="paragraph-custom">
            The Punkypay Mailroom is super cool. 
            It allows you to receive money on any exchange or wallet. 
            The only drawback is that you cannot send money on the Punkypay Mailroom.
          </Paragraph>
          <Paragraph> 
            To watch a video about how to use the Punkypay Mailroom, <a class="light-blue" target="_blank" href="https://youtu.be/w-AdBX8Q0kM">click here</a>. 
          </Paragraph>
          {/* <div className="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/k_oORxBog-g?si=xBiNVQ9Ez-AlszAY"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div> */}
          

          <Title id="WhyPunkypayMailroom" level={4}>Why use the Punkypay Mailroom</Title>
          <Paragraph className="paragraph-custom">
            The Punkypay Mailroom directs all incoming USDC on Punkypay to any exchange you would like. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            This is great for two reasons:
          </Paragraph>
          <div style={{ textIndent: '1em' }}>
          <ol>
            <Paragraph className="paragraph-custom">
            1) You can receive money at any exchange. 
            </Paragraph>
            <Paragraph className="paragraph-custom">
            2) You can withdraw money from Metmask to the Punkypay Mailroom for free. 
            Check out our <a class="light-blue" href="#Withdrawing from Metamask">Internal Accounts</a> section for more details. 
            </Paragraph>
          </ol>
          </div>
          

          <Title id="How to use Punkypay Mailroom" level={4}>How to use the Punkypay Mailroom</Title>
          <Paragraph className="paragraph-custom">
            To use the Punkypay Mailroom, you must input an Ethereum USDC address. 
            After you hit save, all payments made to you will be sent to this address. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            When you enter the Ethereum USDC address, please ensure that you are entering the correct address. 
            {/* You can test that you entered the correct address by having a friend send you $1.  */}
            {/* or emailing us at <a class="light-blue" href="mailto:support@punkypay.com">support@punkypay.com</a> */}
          </Paragraph>

          <Title id="Find Valid Address" level={4}>Finding a valid Ethereum USDC address</Title>

          <Paragraph className="paragraph-custom">
            An Ethereum USDC address is an Ethereum address which can accept USDC. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Before Punkypay, you would have to find a valid Ethereum USDC address every single time you would try to receive money. 
            But with Punkypay, you just have to do this once. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            Finding a valid Ethereum USDC address can be confusing for a variety of reasons.
          </Paragraph>
          <Paragraph className="paragraph-custom">
            An Ethereum USDC address always looks like "0x..." 
            However, not all addresses in this format accept Ethereum USDC. 
           </Paragraph>
          <Paragraph className="paragraph-custom">
            Because you cannot look at the address and determine it is valid, you must be extremely careful when you retrieve the address. 
          </Paragraph>

          <Paragraph className="paragraph-custom">
            When you get your Ethereum USDC address, we recommend:
          </Paragraph>
            <div style={{ textIndent: '1em' }}>
            <ol>
              <Paragraph className="paragraph-custom">
                1) Google "How to receive USDC on the Ethereum Blockchain with my_exchange". 
              </Paragraph>
              <Paragraph className="paragraph-custom">
                2) Once you find this, we recommend having somebody send you a small amount of Ethereum USDC to this address to ensure that it works correctly. 
              </Paragraph>
            </ol>
            </div>
            <Paragraph className="paragraph-custom">
                You can reach out to <a class="light-blue" href="mailto:support@punkypay.com">support@punkypay.com</a> and we will be happy to assist. 
            </Paragraph>

          <Title id="Address Problems" level={4}>Things to Lookout For When Retrieving Ethereum USDC Address</Title>
            <Paragraph className="paragraph-custom">
            Retrieving your Ethereum USDC address is confusing because of the following reasons:
            </Paragraph>

            <div style={{ textIndent: '1em' }}>
              <ol>
              <Paragraph className="paragraph-custom">
              1) Some wallets/exchanges may refer to your "Ethereum USDC" address as simply your "USDC" address. 
              </Paragraph>
              <Paragraph className="paragraph-custom">
              2) Some wallets/exchanges refer to your "Ethereum USDC" address as simply your "Ethereum" address, while other wallets require that only Ethereum be sent to that address.
              </Paragraph>
              <Paragraph className="paragraph-custom">
              3) Some wallets/exchanges have things like "Bridged" USDC on various blockchains. 
              </Paragraph>
              <Paragraph className="paragraph-custom">
              4) Some wallets/exchanges have many addresses that look exactly like your Ethereum USDC address, but are not Ethereum USDC addresses. 
              </Paragraph>
              <Paragraph className="paragraph-custom">
              5) An Ethereum USDC address is not human-readable. 
              </Paragraph>
              </ol>
            </div>

          <Title id="Find Valid Address Coinbase" level={5}>Example: Finding Ethereum USDC Address on Coinbase</Title>
            <Paragraph className="paragraph-custom">
              On some exchanges, you have to 1) select the correct version of USDC and then 2) select the Ethereum blockchain. 
              On other excahnges, you just need to select "USDC" in order to get USDC on the Ethereum blockchain. 
              This is confusing, so we recommend researching how this works on your exchange or emailing them directly. 
            </Paragraph>
            <Paragraph className="paragraph-custom">
              On Coinbase, you need to both 1) select the correct version of USDC and then 2) select the Ethereum blockchain. 
              Please see below: 
            </Paragraph>
            <Paragraph className="paragraph-custom">
              Step 1: Select the correct version of USDC:
            </Paragraph>
              <Image
                src={usdcAddressesCoinbase}
                alt="usdcAddressesCoinbase"
                style={{
                  maxWidth: '132px',
                  maxHeight: '293px',
                  width: '100%',
                  height: 'auto',
                }}
                preview={{
                  mask: <span>Click to enlarge</span>, // Optional overlay text
                }}
              />

            <Paragraph className="paragraph-custom">
              Step 2: Select the Ethereum blockchain:
            </Paragraph>
              <Image
                src={networksEthereunUSDCCoinbadse}
                alt="networksEthereunUSDCCoinbadse"
                style={{
                  maxWidth: '132px',
                  maxHeight: '293px',
                  width: '100%',
                  height: 'auto',
                }}
                preview={{
                  mask: <span>Click to enlarge</span>, // Optional overlay text
                }}
              />
            <Paragraph className="paragraph-custom">
              Please be careful that you select USDC and that you are sending it on the Ethereum blockchain. 
              As you can see below, an Ethereum address may look identical to a USDC address but if you send USDC to the Ethereum address you will lose your money. 
            </Paragraph>
            <Paragraph className="paragraph-custom">
              We *highly* recommend doing research about your specific exchange or wallet on how to correctly pick the Ethereym USDC address. 
            </Paragraph>
          
            <Title id="Illustrating Confusion" level={4}>Illustrating why Ethereum USDC addresses are Confusing on Platforms like Coinbase</Title>
            <Paragraph className="paragraph-custom">
            In this section, we are just further elaborating why these addresses are confusing. 
            </Paragraph>
            <Paragraph className="paragraph-custom">
            Some people believe that using blockchain is easy, and we're just going overboard to prove them wrong here. 
            All of the addresses are from the Coinbase crypto exchange:
            </Paragraph>
            <Paragraph className="paragraph-custom">
            The below is a USDC address on the Ethereum blockchain: 
            You CAN receive money on Punkypay if you enter this address into your Punkypay Mailroom.:
            </Paragraph>
            <Paragraph className="paragraph-custom" style={{ fontSize: "18px" }}>
            0xe5b3bB949D3e12BE15366C97000717AA6BBe55Ca
            </Paragraph>
            <Paragraph className="paragraph-custom">
            The below is an Ethereum address (not an "Ethereum USDC" address). 
            You SHOULD NOT enter this address into the Punkypay Mailroom:
            </Paragraph>
            <Paragraph className="paragraph-custom" style={{ fontSize: "18px" }}>
            0xccE8779Efe3Bb84C46b0F875aAc39fFf5C6F70B2
            </Paragraph>
            <Paragraph className="paragraph-custom">
            The below is a "VeChain" address. 
            Notice it looks exactly the same as the above two addresses. 
            You SHOULD NOT entere this into the Punkypay Mailroom:  
            </Paragraph>
            <Paragraph className="paragraph-custom" style={{ fontSize: "18px" }}>
            0x3DfF96c498797137AF21d9d38bF46C14008E8634
            </Paragraph>
            <Paragraph className="paragraph-custom">
            We realize this is confusing as heck, so be careful! 
            We *highly* recommend doing research about your specific exchange or wallet on how to correctly pick the Ethereym USDC address. 
            </Paragraph>

          <Title id="Find Valid Address Metamask" level={5}>Example: Finding Ethereum USDC Address on Metamask</Title>
            <Paragraph className="paragraph-custom">
              On the Metamask wallet, you need to select your Ethereum address and are able to send USDC to that. 
              There is no term "Ethereum USDC address" or anything like that...instead, you must use your general "Ethereum" address to receive USDC on the Etherum blockchain. 
              However, on the Metamask wallet, you are able to receive USDC at your general "Ethereum" address - unlike how on Coinbase you must receive USDC on your "Ethereum USDC" address. 
            </Paragraph>
              <Image
                src={metamaskEthereumAddressExample}
                alt="metamaskEthereumAddressExample"
                style={{
                  maxWidth: '132px',
                  maxHeight: '293px',
                  width: '100%',
                  height: 'auto',
                }}
                preview={{
                  mask: <span>Click to enlarge</span>, // Optional overlay text
                }}
              />
            <Paragraph className="paragraph-custom">
              We *highly* recommend doing research about your specific exchange or wallet on how to correctly pick the Ethereym USDC address. 
            </Paragraph>
          <Title id="How to Pay Someone in China" level={2}>How to Pay Someone in China</Title>
          <Paragraph className="paragraph-custom">
            While using blockchain technology is largely forbidden in Mainland China, there are still ways to legally pay someone. 
            There are a variety of fintechs that allow you to send money to Mainland China, but today we are going to focus on how to use <a class="light-blue" target="_blank" href="https://bank.za.group/en">ZA Bank</a>. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            ZA Bank is a bank based in Hong Kong. 
            However, it also has the ability to hold, send, and receive cryptocurrencies like USDC. 
            The reason why ZA Bank is awesome is because you can receive money in USDC, exchange that USDC for CNY, and then forward the CNY to Mainland China. 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            In order to use ZA Bank with Punkypay, simply enter the Ethereum USDC address you find in your ZA Bank account into the Punkypay Mailroom. 
          </Paragraph>
          

          <Title id="How to open a ZA Bank Account" level={3}>How to open a ZA Bank Account</Title>
          <Paragraph className="paragraph-custom">
            To see how to open an account, <a class="light-blue" target="_blank" href="https://bank.za.group/en/account-open">click here</a>. 
          </Paragraph>

          <Title id="Referrals" level={3}>Referrals</Title>
          <Paragraph className="paragraph-custom" >
            Turn your network into earnings with Punkypay. 
            When you refer a friend, you’ll earn <b>50% of the platform fees</b> Punkypay collects from them for the first <b>five years</b> after they sign up. 
          </Paragraph>
          <Paragraph className="paragraph-custom"> 
            <i>Example: Bob refers Alice to Punkypay. 
              Alice then receives money from Carol. 
              Once Alice has received enough funds, Punkypay charges Alice a platform fee, and Bob earns 50% of that fee. 
            </i>
          </Paragraph>
          <Paragraph className="paragraph-custom" >
            <b>It gets even better.</b> 
            When your friend pays someone who hasn’t been referred to Punkypay, you’ll also earn the platform fees generated from that recipient. 
            That means your earning potential can grow beyond just one connection.
          </Paragraph>
          <Paragraph className="paragraph-custom">
            <i>Example: 
              Bob refers Alice to Punkypay. 
              Alice then sends money to Carol. 
              Because Carol was not referred to Punkypay by anyone, Bob earns 50% of the platform fees that Carol pays when receiving money from Alice. 
            </i>
          </Paragraph>
          <Paragraph className="paragraph-custom">
            These fees add up — putting money in your pocket while your friends save money and time. 
          </Paragraph>
          <Title id="Referrals" level={4}>How to Get a Referral</Title>
          <Paragraph className="paragraph-custom">
            In order to get a referral on Punkypay, you must a) have an account with Punkypay and b) have signed into an exchange. (eg, sign in with Coinbase, Metmask, the Punkypay Mailroom, etc.) 
          </Paragraph>
          <Paragraph className="paragraph-custom">
            There are two ways to get logged in our database as a referrer: 
          </Paragraph>

            <div style={{ textIndent: '1em' }}>
              <ol>
                <Paragraph className="paragraph-custom">
                  1) When you refer someone to Punkypay, ask them to enter your email in the “Referrer’s Email” box when you register.
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  2) If they did not do this, you can ask Punkypay to manually add you as a referrer in our database. We will allow you to manually add people within 30ish days. 
                </Paragraph>
                <Paragraph className="paragraph-custom">
                  In order to ask us, email <a class="light-blue" href="mailto:support@punkypay.com">support@punkypay.com</a>
                </Paragraph>
              </ol>
            </div>

          <Title id="edge-cases" level={2}>Edge Cases</Title>

          <Title id="disconnected-during-send" level={3}>What to do if you disconnect from the internet while sending money?</Title>
            <Paragraph className="paragraph-custom">
              Don't worry. 
              Your money is safe. 
            </Paragraph>    

            <Paragraph className="paragraph-custom">
              If you disconnect from Punkypay while you are trying to send money, Punkypay may not be able to record the transaction. 
              However, your money is safe.
            </Paragraph>  
            <Paragraph className="paragraph-custom">
              Your money is in one of two places: it is either still in your wallet/exchange, or it has been sent to the recipient.
            </Paragraph>    
            <Paragraph className="paragraph-custom">
              To find out where your money is, look in your wallet/exchange for a transaction that was sent around the same time that you tried to send your money. 
            </Paragraph>      
            <Paragraph className="paragraph-custom">
              If you DO NOT see a corresponding transaction, then the transaction was not sent. 
              Try resending the money on Punkypay.
            </Paragraph>     
            <Paragraph className="paragraph-custom">
              If you DO see a corresponding transaction, then the transaction was sent to the recipient. 
              Because Punkypay was not able to record the transaction, we recommend following up with the recipient via email. 
            </Paragraph>     
            <Paragraph className="paragraph-custom">
              Here's an example of this email:
            </Paragraph>     
            
            <div style={{
              backgroundColor: '#202020',
              borderRadius: '8px',
              padding: '16px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
            }}>  
              <Paragraph className="paragraph-custom" >
                  &lt;Name_of_Recipient&gt;
              </Paragraph>     
              <Paragraph className="paragraph-custom" >
                  Recently I was sending $x.xx to you for &lt;Reason_of_Purchase&gt; on Punkypay. 
              </Paragraph>      
              <Paragraph className="paragraph-custom" >
                  Unfortunately, there was a network issue while I was submitting the transaction, so Punkypay was unable to record the transaction. 
              </Paragraph>      
              <Paragraph className="paragraph-custom" >
                  You will see that a transaction was sent to you at &lt;Date_and_Time_of_Transaction&gt; for $x.xx. The transaction id is &lt;Transaction_id&gt; 
                  <i>
                     (You are able to find the transaction id within your exchange/wallet. 
                    If you can't locate this easily, the recipient might be able to find the transaction by looking for the date and time the transaction as sent and the amount of money you sent.)
                  </i>
              </Paragraph>  
              <Paragraph className="paragraph-custom" >
                I apologize for the inconvenience this may cause. 
                If you have any questions, please reach out!
              </Paragraph>   
              <Paragraph className="paragraph-custom" >
                Much appreciated, 
              </Paragraph>
              <Paragraph className="paragraph-custom" >
                &lt;Senders_Name&gt;
              </Paragraph>
            </div>

            <Title id="network-congestion" level={3}>Network Congestion</Title>
            <Paragraph className="paragraph-custom" >
              On extremely rare occasions, network congestion may cause your transaction to take longer than a few minutes to send. 
              (This issue is so rare that when we tested Punkypay we never had this problem.)
            </Paragraph>
            <Paragraph className="paragraph-custom"> 
              If you are using Coinbase, it will take longer before the status moves from a "pending" state to "completed". 
            </Paragraph>
            <Paragraph className="paragraph-custom" >
              If you are using Metamask, you must stay connected to Punkypay for the entire duration that the transaction is trying to send.
              When the transaction eventually takes place, Punkypay will to record the transaction as long as you do not leave Punkypay or close your browser. 
            </Paragraph>
            <Paragraph className="paragraph-custom">
              If the transaction does not occur after 48 hours, feel free to contact us. 
              If you disconnect from the internet before the transaction occurs, please see the above section. 
            </Paragraph>

            <Title id="sent-to-wrong-person" level={3}>What to do if you sent money to the wrong person</Title>
            <Paragraph className="paragraph-custom" >
              While it would be unfortunate if you sent money to the wrong person on Punkypay, there may still be a way to recover it. 
            </Paragraph>
            <Paragraph className="paragraph-custom" >
              You can email the person who you accidentally sent money to and ask them to return it. 
              Because all blockchain transactions are final, there is no way for Punkypay to recover the money on your behalf. 
            </Paragraph>
        </Col>
      </Row>
    </div>
  );
};

export default Support;